module.exports = __webpack_public_path__ + "static/media/animated-caro-starting-checklist.595715b1.mp4";